import { useCallback } from 'react';

/**
 * Checks if a element's content is overflown.
 */
export function isElementOverflown(element: HTMLElement): boolean {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

/**
 * Add a `title` tooltip to an element that is overflown.
 */
export const useTooltip = <R extends HTMLElement>(tooltip?: string): React.Ref<R> => {
  const overflownRef = useCallback((node: R) => {
    if (node && tooltip) {
      if (isElementOverflown(node)) {
        node.title = tooltip;
      }
    }
  }, []);

  return overflownRef;
};
